<template>
  <div :class="$style.resource_cell">
    <div
      v-for="(res, index) in trimmedResources"
      :key="index"
    >
      <svg-sprite
        v-if="res.id === '-1'"
        :class="$style.avatar"
        name="assigned"
        type="regular"
        color="#B2B2B2"
        :size="24"
      />
      <vgp-avatar
        v-else
        :style="index > 0 ? {marginLeft: '-8px'} : null"
        :class="$style.avatar"
        :src="res.img || res.photo"
        :custom-size="24"
      />
    </div>
    <div
      v-if="allResources.length > 4"
      :class="[$style.value, $style.text_bold, $style.chip_counter]"
    >
      +{{ allResources.length - 4 }}
    </div>
    <div
      v-if="allResources.length === 1"
      :class="{
        [$style.value]: true,
        [$style.text_bold]: isGroupCell
      }"
      :style="{paddingLeft: '4px', maxWidth: isGroupCell ? firstColumnWidth : resourceNameWidth}"
    >
      {{ trimmedResources[0].name }}
    </div>
  </div>
</template>

<script>
import vgpAvatar from '../../../common/VueComponents/avatar/vgpAvatar.vue';

export default {
  components: { vgpAvatar },
  props: {
    cell: { type: Object, required: true },
    columnsSizes: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    isGroupCell() {
      return this.cell.getIsGrouped();
    },
    firstColumnWidth() {
      const firstColumnWidth = Object.values(this.columnsSizes)
        .slice(0, 3)
        .reduce((sum, value) => sum + parseFloat(value), 0);
      const width = firstColumnWidth - 200;

      return `${width}px`;
    },
    resourceNameWidth() {
      const columnWidth = this.columnsSizes[this.cell.column.id];
      const resultWidth = parseFloat(columnWidth) - 52;

      return `${resultWidth}px`;
    },
    allResources() {
      const resourcesData = this.cell.row.original[this.cell.column.id];
      let resources = [];

      if (Array.isArray(resourcesData) && resourcesData.length) {
        resources = resourcesData;
      } else if (resourcesData && typeof resourcesData === 'object' && !Array.isArray(resourcesData)) {
        resources = [resourcesData];
      } else {
        resources.push({ id: '-1', name: __('notAssigned') });
      }

      return resources;
    },
    trimmedResources() {
      return this.allResources.slice(0, 4);
    },
  },
};
</script>

<style module src="./cell.less" lang="less"></style>
